import { Container, Flex, Heading } from '@chakra-ui/react';
import { getTenantByHost } from '@pelicargo/tenants';
import Markdown from 'react-markdown';

import { Page } from '../../components/Page';

export const Terms = () => {
  return (
    <Page title="Terms & Conditions">
      <Container maxW="container.lg" p="8">
        <Flex gap={3} direction="column">
          <Markdown
            components={{
              h1: Heading,
              h2: (args) => <Heading {...args} size="lg" />,
              h3: (args) => <Heading {...args} size="md" />,
            }}
          >
            {getTenantByHost().termsOfService}
          </Markdown>
        </Flex>
      </Container>
    </Page>
  );
};
